module.exports = __webpack_public_path__ + "static/media/DiagnosticServicesInner.1df88fb1.png";